import { createFileRoute } from "@tanstack/react-router";
import Left from "@repo/icons/default/Left";
import {
  HeaderButton,
  HeaderRoot,
  HeaderTitle,
} from "@/components/ui/layout/header/header";
import { Page } from "@/components/ui/layout/page/page";
import { ReservedScheduleStartingDayForm } from "@/components/reserved-schedules/reserved-schedule-starting-day-form";

import type { JSX } from "react";

const ReservedScheduleStartingDayPage = (): JSX.Element => {
  return (
    <>
      <HeaderRoot>
        <HeaderButton icon={Left} align="start" />
        <HeaderTitle title="Novo período garantido" align="center" />
      </HeaderRoot>
      <Page>
        <ReservedScheduleStartingDayForm />
      </Page>
    </>
  );
};

export const Route = createFileRoute("/settings/reserved-schedules/create/starting-day")({
  component: ReservedScheduleStartingDayPage,
});
